export default "__VITE_ASSET__bd4fec25__"